module.exports = __webpack_public_path__ + "img/build-logs.c1ba52db.png";